export default __webpack_public_path__ + "static/media/kledeboer.e2ba2f76.png";